import { inviteLinkInitialData } from '../types/InitialData';

export type InviteLinkTableType = {
  link: string
  preset: {}
}

const convertToPendingInviteReport = (data: inviteLinkInitialData): InviteLinkTableType[] => {

  const inviteLinks = data?.links ?? []

  const inviteLinksData = inviteLinks.map( inviteLink => ({
    link: inviteLink.link ?? '',
    preset: inviteLink.preset ?? {}
  }));

  return inviteLinksData;

}

export const InviteLinkTableData = (data: inviteLinkInitialData): InviteLinkTableType[] => {
  return convertToPendingInviteReport(data)
}
